import { useState } from 'react';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../lib/firebase';
import type { User } from 'firebase/auth';

interface AuthFormProps {
    user: User | null;
    onAuthChange: (user: User | null) => void;
}

export default function AuthForm({ user, onAuthChange }: AuthFormProps) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            onAuthChange(userCredential.user);
        } catch (err: unknown) {
            const errorMessage = err instanceof Error ? err.message : 'Errore sconosciuto';
            setError('Errore di autenticazione: ' + errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = async () => {
        try {
            await signOut(auth);
            onAuthChange(null);
        } catch (err: unknown) {
            const errorMessage = err instanceof Error ? err.message : 'Errore sconosciuto';
            setError('Errore logout: ' + errorMessage);
        }
    };

    if (user) {
        return (
            <div className="max-w-md mx-auto p-6 bg-green-50 rounded-lg border border-green-200">
            <div className="text-center">
            <p className="text-green-700 mb-4">
            ✅ Autenticato come: <strong>{user.email}</strong>
        </p>
        <button
        onClick={handleLogout}
        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
            >
            Logout
            </button>
            </div>
            </div>
    );
    }

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6">Accesso Test</h2>

    <form onSubmit={handleLogin} className="space-y-4">
    <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
        Email
        </label>
        <input
    type="email"
    id="email"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    required
    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
    />
    </div>

    <div>
    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
        Password
        </label>
        <input
    type="password"
    id="password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    required
    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        />
        </div>

        <button
    type="submit"
    disabled={loading}
    className="w-full bg-blue-500 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-2 px-4 rounded"
        >
        {loading ? 'Accesso in corso...' : 'Accedi'}
        </button>
        </form>

        <p className="text-sm text-gray-600 mt-4 text-center">
        ⚠️ Utilizzare un account di test per accedere alle API
    </p>

    {error && (
        <div className="mt-4 p-3 bg-red-100 text-red-700 rounded text-sm">
            {error}
            </div>
    )}
    </div>
);
}